const tagsContentString = metaArticleTags => {
  let contentString = '';
  for (let i = 0; i < metaArticleTags.length; i += 1) {
    contentString += metaArticleTags[i].getAttribute('content');
    if (i < metaArticleTags.length - 1) {
      contentString += ', ';
    }
  }
  return contentString;
};

const metaArticleTagsReducer = metaArticleTags => ({
  tags: tagsContentString(metaArticleTags)
});

export default () => {
  const metaArticleTags = document.querySelectorAll(
    "meta[property='article:tag']"
  );

  if (metaArticleTags && metaArticleTags.length > 0) {
    return metaArticleTagsReducer(metaArticleTags);
  }
  return {};
};
